import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { v as validateElementContainer } from './form-4ba95191.js';

const dsFormCss = "ds-form{display:block}";

const DsForm = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.valid = createEvent(this, "valid", 7);
    this.submit = createEvent(this, "submit", 7);
    this.isValid = undefined;
  }
  async checkValidity() {
    if (!this.formElement)
      return; // something went wrong
    const isValid = validateElementContainer(this.formElement);
    if (isValid !== this.isValid) {
      this.isValid = isValid;
      this.valid.emit(this.isValid);
    }
    this.formElement.querySelectorAll('ds-fieldset').forEach(fs => fs.checkValidity());
  }
  componentDidLoad() {
    this.checkValidity();
  }
  render() {
    return (h(Host, { "is-valid": this.isValid }, h("form", { autocomplete: "off", ref: el => this.formElement = el, onSubmit: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.submit.emit();
      } }, h("slot", null))));
  }
};
DsForm.style = dsFormCss;

export { DsForm as ds_form };
